import type * as ReactRouter from "react-router";
import { PricingPage } from "~/app/components/landing/pricing-page";
import { getTranslationFn } from "~/app/i18n";

const t = getTranslationFn("en");

export const meta: ReactRouter.MetaFunction = () => [
  { title: t("Pricing.metaTitle") },
  { name: "description", content: t("Pricing.metaDescription") },
];

export default function PricingEN() {
  return <PricingPage locale="en" />;
}
